module.exports = __webpack_public_path__ + "img/glogo295.a5e7f93f.png";